import React from 'react';
import './index.less';

export default ({ size = 'md', className = '', style, onClick }) => {
  const cls = `whitespace whitespace-${size} ${className}`.trim();
  return <div className={cls} style={style} onClick={onClick} />;
};
